<template lang="pug">
section
  s-page-title(title='Типовые планировки')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(:initial='dataFilter.search' @search='debouncedSearch')
      template(slot='controls')
        v-layout
            v-flex(xs12)
              s-complex-picker(
                :value='dataFilter.complex_id'
                @change='changeComplex'
                clearable
              )
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      :rows-per-page-items='dataFilter.rowsPerPageItems'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item.id)')
          td {{ props.item.id }}
          td
            template(v-if='props.item.render_view_url')
              v-img(
                :aspect-ratio='16/9'
                :lazy-src='props.item.render_view_url'
                :src='props.item.render_view_url'
                class='grey lighten-4'
                contain
              )
                v-layout(
                  slot='placeholder'
                  fill-height
                  align-center
                  justify-center
                  ma-0
                )
                  v-progress-circular(indeterminate color='primary')
            template(v-else-if='props.item.placement_sizing_url')
              v-img(
                :aspect-ratio='16/9'
                :lazy-src='props.item.placement_sizing_url'
                :src='props.item.placement_sizing_url'
                class='grey lighten-4'
                contain
              )
                v-layout(
                  slot='placeholder'
                  fill-height
                  align-center
                  justify-center
                  ma-0
                )
                  v-progress-circular(indeterminate color='primary')
            template(v-else-if='props.item.render_plan_url')
              v-img(
                :aspect-ratio='16/9'
                :lazy-src='props.item.render_plan_url'
                :src='props.item.render_plan_url'
                class='grey lighten-4'
                contain
              )
                v-layout(
                  slot='placeholder'
                  fill-height
                  align-center
                  justify-center
                  ma-0
                )
                  v-progress-circular(indeterminate color='primary')
            template(v-else-if='props.item.placement_scheme_url')
              v-img(
                :aspect-ratio='16/9'
                :lazy-src='props.item.placement_scheme_url'
                :src='props.item.placement_scheme_url'
                class='grey lighten-4'
                contain
              )
                v-layout(
                  slot='placeholder'
                  fill-height
                  align-center
                  justify-center
                  ma-0
                )
                  v-progress-circular(indeterminate color='primary')
          td(class='checkbox-wrap')
            v-checkbox(
              v-model='props.item.variants_attached > 0'
              color='primary'
              readonly
            )
          td(class='checkbox-wrap')
            v-checkbox(
              v-model='props.item.pdf_for_print != null'
              color='primary'
              readonly
            )
          td {{ props.item.complex_name }}
          td {{ props.item.layout_name }}
          td {{ props.item.rooms_count }}
          td {{ formatSquare(props.item) }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item.id)')
              v-icon(small) delete_outline
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'

export default {
  data: function() {
    return {
      headers: [
        { text: '#ID', align: 'left', value: 'id', width: '0%' },
        {
          text: 'Фото планировки',
          align: 'left',
          sortable: false,
          width: '25%'
        },
        {
          text: 'Варианты',
          align: 'left',
          value: 'variants_attached',
          width: '10%'
        },
        {
          text: 'PDF',
          align: 'left',
          sortable: false,
          width: '10%'
        },
        {
          text: 'Название комплекса',
          align: 'left',
          value: 'complex_name',
          width: '25%'
        },
        {
          text: 'Название',
          align: 'left',
          value: 'layout_name',
          width: '25%'
        },
        {
          text: 'Кол-во комнат',
          align: 'left',
          value: 'rooms_count',
          width: '10%'
        },
        {
          text: 'Площадь  общая/жилая/кухня',
          align: 'left',
          value: 'square_total',
          width: '15%'
        },
        { text: '', align: 'left', width: '0%', sortable: false }
      ]
    }
  },

  methods: {
    fetch() {
      this.fetchList({ config: { params: this.dataFilter } })
    },

    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    changeComplex(complexId = null) {
      this.setDataFilter({ complex_id: complexId })
      this.fetch()
    },

    formatSquare({ square_total, square_living, square_kitchen }) {
      const f = prop => (prop === null ? '—' : prop)
      return `${f(square_total)}/${f(square_living)}/${f(square_kitchen)}`
    },

    onEdit(layoutId) {
      this.$router.push({
        name: 'Complexes.Layouts.Edit',
        params: { layoutId }
      })
    },

    async onDelete(id) {
      if (await this.$confirm('Удалить планировку?')) {
        try {
          await this.destroy({ id })
        } catch (e) {
          this.$root.showSnack('Ошибка удаления планировки')
        }
        this.fetch()
      }
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('objects/layouts', ['fetchList', 'destroy']),
    ...mapMutations('objects/layouts', ['setDataFilter'])
  },

  computed: {
    ...mapState('objects/layouts', ['total', 'dataFilter']),
    ...mapGetters('objects/layouts', ['list', 'isLoading'])
  }
}
</script>

<style scoped>

.comment {
  color: #afafaf;
}
</style>